/* eslint-disable */
import { put, call, takeEvery, select, all, spawn } from 'redux-saga/effects'
import moment from 'moment-timezone'
import ProfileActions from './actions'
import {
  storeHistory,
  historyNotes,
  UpdateHistory,
  getDeviceLastTwoHourData,
  getDeviceRawRR,
  getPatientBoxPlotData,
  // getPatientTiBData,
  getAllStoredNotesOfPatient,
  profileSetState,
  changeDeviceName,
  settingsSetState,
} from '../actions'
import { apiPaths } from '../../config'
import { LISTEN_TO_SOCKET, CLOSE_SOCKET } from '../socketLiveRespiration/sagas'
import { GET_CLINIC_DEVICES_DB, GET_CLINIC_DEVICES } from '../device/sagas'
import { uploadFile } from '../clinicPatient/sagas'
import { notification, analytics, http } from '../../services/index'

const getProfile = (state) => state.profile
const getUser = (state) => state.user
const getDevice = (state) => state.device
const getClinic = (state) => state.clinic
const getClinicPatient = (state) => state.clinicPatient

const getDailyPatientReport = (payload) =>
  http
    .get(apiPaths.Clinic.apidailyPatientReport, payload, {})
    .then((res) => res)
    .catch(() => [])

export function* toggleCalendar() {
  yield put(settingsSetState({ isSettingsOpen: true }))
}

export function* STORE_HISTORY_NOTES({ payload }) {
  yield put(profileSetState({ noteLoading: true, noteListLoading: true }))
  payload.uploadedFile = null
  if (payload.noteFileList && payload.noteFileList.length > 0) {
    const [fileList] = payload.noteFileList
    const fileNameStatic = fileList.name
    const fileName = yield call(
      uploadFile,
      'clinicPatient',
      fileList.originFileObj,
      `${fileNameStatic.split('.')[0]}-${payload.member_id}-${fileList.lastModified}`,
    )
    payload.uploadedFile = fileName
  }
  const historyStored = yield call(storeHistory, payload)
  if (historyStored === 'success') {
    notification.success(`Success`, 'Note stored successfully')
  }
  yield put(profileSetState({ historyStored }))
  const getHistoryNotes = yield call(historyNotes, payload)
  const [lastHistoryNote] = getHistoryNotes
  const { clinicPatientsList } = yield select(getClinicPatient)
  clinicPatientsList.map((value) => {
    if (value.patient_id === payload.member_id) {
      value.lastNote = lastHistoryNote
    }
    return true
  })
  yield call(GET_HISTORY_NOTES, { payload })
  yield put(
    profileSetState({
      noteLoading: false,
      noteListLoading: false,
      historyStored,
      getHistoryNotes,
    }),
  )
}

export function* UPDATE_HISTORY_NOTE({ payload }) {
  yield put(profileSetState({ noteListLoading: true }))
  const historyUpdated = yield call(UpdateHistory, payload)
  const getHistoryNotes = yield call(historyNotes, {
    member_id: payload.member_id,
    clinic_id: payload.clinic_id,
  })
  yield put(profileSetState({ noteListLoading: false, historyUpdated, getHistoryNotes }))
}

export function* GET_RESIDENT_STATUS_NOTES({ payload }) {
  const { userUID } = payload
  yield put(profileSetState({ noteListLoading: true }))

  const getResidentStatus = yield call(getAllStoredNotesOfPatient, { patient_id: userUID })
  // if (getResidentStatus.length > 0) {
  //   getResidentStatus = getResidentStatus.reverse()
  // }
  yield put(profileSetState({ noteListLoading: false, getResidentStatus }))
}

export function* GET_HISTORY_NOTES({ payload }) {
  const { userUID } = payload
  yield put(profileSetState({ noteListLoading: true }))
  const { userClinic } = yield select(getClinic)
  payload.member_id = userUID
  payload.userUID = userUID
  payload.clinic_id = userClinic.id
  const getHistoryNotes = yield call(historyNotes, payload)
  yield call(GET_RESIDENT_STATUS_NOTES, { payload })
  yield put(profileSetState({ noteListLoading: false, getHistoryNotes }))

  analytics.event({
    action: ProfileActions.GET_HISTORY_NOTES,
    category: 'profile',
    label: 'Notes',
    value: payload,
  })
}

export const convertMinsToHrsMins = (
  mins,
  skipRangeCondition = false,
  onlyShowHoursIfAvailable = false,
) => {
  // do not include the first validation check if you want, for example,
  // getTimeFromMins(1530) to equal getTimeFromMins(90) (i.e. mins rollover)

  if ((mins >= 24 * 60 || mins < 0) && !skipRangeCondition) {
    throw new RangeError('Valid input should be greater than or equal to 0 and less than 1440.')
  }
  const h = (mins / 60) | 0 // eslint-disable-line no-bitwise
  const m = mins % 60 | 0 // eslint-disable-line no-bitwise
  // if (mins > 30) {
  //   h += 1
  // }
  if (mins === 0) {
    return '0'
  }
  if (h === 0) {
    if (onlyShowHoursIfAvailable) {
      return `${moment.utc().minutes(m).format('mm[m]')}`
    }
    return `0h ${moment.utc().minutes(m).format('mm[m]')}`
  }
  return moment.utc().hours(h).minutes(m).format('h[h] mm[m]')
}

export const convertMinsToHrsMins2 = (mins) => {
  // do not include the first validation check if you want, for example,
  // getTimeFromMins(1530) to equal getTimeFromMins(90) (i.e. mins rollover)
  if (mins >= 24 * 60 || mins < 0) {
    throw new RangeError('Valid input should be greater than or equal to 0 and less than 1440.')
  }
  let h = (mins / 60) | 0 // eslint-disable-line no-bitwise
  const m = mins % 60 | 0 // eslint-disable-line no-bitwise
  if (mins > 30) {
    h += 1
  }
  if (mins === 0 || mins === null) {
    return '0'
  }
  return moment.utc().hours(h).minutes(m).format('h')
}

export function* GET_LIVE_DEVICE_DATA({ payload }) {
  yield put(profileSetState({ graphLoading: true }))
  const { userClinic } = yield select(getClinic)
  const { id } = userClinic
  payload.clinic_id = id
  payload.hours = 2
  const lastTwoHourData = yield call(getDeviceLastTwoHourData, payload)
  yield put(profileSetState({ lastTwoHourData, graphLoading: false }))
}

export function* GET_CURRENT_DEVICE({ payload }) {
  const { inventoryListingDevices } = yield select(getDevice)
  let { profileTimezone } = yield select(getProfile)
  const currentDevice = {}

  if (inventoryListingDevices.data) {
    Object.assign(
      currentDevice,
      ...inventoryListingDevices.data.filter((item) => item.device_id === payload.device_id),
    )
  }
  let timezone
  if (currentDevice.tz) {
    const { tz } = currentDevice
    timezone = tz
  } else {
    const { device_tz: tz } = currentDevice
    timezone = tz
  }
  profileTimezone = timezone
  yield put(profileSetState({ currentDevice, profileTimezone }))
}

export function* GET_BOX_PLOT_DATA_HISTORY({ payload }) {
  const { report, dates } = payload
  yield put(profileSetState({ boxPlotLoading: true }))
  let { boxPlotData } = yield select(getProfile)
  const { userClinic } = yield select(getClinic)
  payload.clinic_id = userClinic.id
  let dailyDataResponse = []
  let dailyTiBDataResponse = []
  let response = []
  let monthlyTiBResponse = []
  payload.type = payload.report
  payload.structure = 'in'
  /* eslint-disable */
  if (report === 'daily' && dates.length > 0) {
    payload.report = 'triad'
    payload.type = 'triad'
    const fatchedDate = yield call(getPatientBoxPlotData, payload)
    dailyDataResponse = fatchedDate.rr ? fatchedDate.rr : []
    dailyTiBDataResponse = fatchedDate.tib ? fatchedDate.tib : []
    /* eslint-enable */
  } else {
    // profileTimer = new Date().getTime()
    // const [RR, TiB] = yield all([
    //   call(getPatientBoxPlotData, payload),
    //   call(getPatientTiBData, payload),
    // ])
    const fatchedDate = yield call(getPatientBoxPlotData, payload)
    response = fatchedDate.rr ? fatchedDate.rr : []
    monthlyTiBResponse = fatchedDate.tib ? fatchedDate.tib : []
  }

  let newResponse = {}
  if (report === 'daily') {
    newResponse = {
      daily: dailyDataResponse,
      dailyTiB: dailyTiBDataResponse,
    }
  } else if (report === 'weekly') {
    newResponse = {
      weekly: response,
    }
  } else if (report === 'monthly') {
    newResponse = {
      monthly: response,
      monthlyTiB: monthlyTiBResponse,
    }
  }

  boxPlotData = Object.assign(boxPlotData, newResponse)

  yield put(profileSetState({ boxPlotData, boxPlotLoading: false, dates }))

  analytics.event({
    action: ProfileActions.GET_BOX_PLOT_DATA_HISTORY,
    category: 'profile',
    label: 'onTabClick',
    value: payload,
  })
}

export function* GET_DEVICE_RAW_RR({ payload }) {
  const { report, dates } = payload
  yield put(profileSetState({ boxPlotLoading: true }))
  const { userClinic } = yield select(getClinic)
  payload.clinic_id = userClinic.id
  let { deviceRawRR } = yield select(getProfile)

  /* eslint-enable */
  const response = yield call(getDeviceRawRR, payload)

  let newResponse = {}
  if (report === 'daily') {
    newResponse = {
      daily: response,
    }
  } else if (report === 'weekly') {
    newResponse = {
      weekly: response,
    }
  } else if (report === 'monthly') {
    newResponse = {
      monthly: response,
    }
  }

  deviceRawRR = Object.assign(deviceRawRR, newResponse)
  yield put(profileSetState({ deviceRawRR, boxPlotLoading: false, dates }))

  analytics.event({
    action: ProfileActions.GET_DEVICE_RAW_RR,
    category: 'profile',
    label: 'Hourly > Raw',
    value: payload,
  })
}

export function* SOCKET_HANDLER({ payload }) {
  const { type, deviceId, patientDetail } = payload
  const { token } = yield select(getUser)
  if (type === 'connect') {
    const { memberDetail } = yield select(getProfile)
    const { userClinic } = yield select(getClinic)
    yield spawn(LISTEN_TO_SOCKET, {
      payload: {
        jwtToken: token,
        deviceId,
        patientId: patientDetail ? patientDetail.patient_id : memberDetail.patient_id,
        clinicId: userClinic.id,
      },
    })
  } else {
    yield call(CLOSE_SOCKET)
    yield put(profileSetState({ socketConnectionData: false }))
  }
}

export function* UPDATE_THRESHOLD({ payload }) {
  if (payload.isProfile) {
    const { currentDevice } = yield select(getProfile)
    payload.device_id = currentDevice.device_id
  }
  const response = yield call(changeDeviceName, payload, 'Device settings has been changed')
  if (response === 'success') {
    yield all([
      call(GET_CLINIC_DEVICES, { payload: { page: payload.page || 1 } }),
      call(GET_CLINIC_DEVICES_DB),
      call(GET_CURRENT_DEVICE, { payload: { deviceID: payload.device_id } }),
    ])
  }
}

export function* GET_DAILY_PATIENT_REPORT({ payload }) {
  const response = yield call(getDailyPatientReport, payload)
  yield put(profileSetState({ dailyPateintReportRR: response }))
}

export default function* rootSaga() {
  yield all([
    takeEvery(ProfileActions.STORE_HISTORY_NOTES, STORE_HISTORY_NOTES),
    takeEvery(ProfileActions.GET_RESIDENT_STATUS_NOTES, GET_RESIDENT_STATUS_NOTES),
    takeEvery(ProfileActions.GET_HISTORY_NOTES, GET_HISTORY_NOTES),
    takeEvery(ProfileActions.UPDATE_HISTORY_NOTE, UPDATE_HISTORY_NOTE),
    takeEvery(ProfileActions.GET_LIVE_DEVICE_DATA, GET_LIVE_DEVICE_DATA),
    takeEvery(ProfileActions.SOCKET_HANDLER, SOCKET_HANDLER),
    takeEvery(ProfileActions.GET_BOX_PLOT_DATA_HISTORY, GET_BOX_PLOT_DATA_HISTORY),
    takeEvery(ProfileActions.GET_CURRENT_DEVICE, GET_CURRENT_DEVICE),
    takeEvery(ProfileActions.UPDATE_THRESHOLD, UPDATE_THRESHOLD),
    takeEvery(ProfileActions.GET_DEVICE_RAW_RR, GET_DEVICE_RAW_RR),
    takeEvery(ProfileActions.GET_PATIENT_RR_24_72_HRs, GET_DAILY_PATIENT_REPORT),
  ])
}
